export class MarketPosturaBody {
  BuyPrice: number; // tslint:disable-line
  BuyVolume: number; // tslint:disable-line
  BuyOrdersNum: number; // tslint:disable-line
  SellPrice: number; // tslint:disable-line
  SellVolume: number; // tslint:disable-line
  SellOrdersNum: number; // tslint:disable-line
}
